module.exports = __webpack_public_path__ + "img/email.7dd69392.svg";